import { createRoot } from 'react-dom/client';
import 'sonner/dist/styles.css';

import { initApm } from '@/apm';
import { App } from '@/app';
import '@/index.css';

initApm();

const bootstrap = async () => {
  const shouldUseMock = import.meta.env.VITE_USE_MOCK === 'true';
  if (import.meta.env.DEV && shouldUseMock) {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }

  createRoot(document.getElementById('root')!).render(<App />);
};

bootstrap();
